<template>
  <span>
    <span
      v-b-tooltip.hover
      :title="tipoStatus[id_status].title"
      :class="`badge badge-${tipoStatus[id_status].class}`"
    >
      <font-awesome-icon :icon="`fa-solid fa-${tipoStatus[id_status].icon}`" />
    </span>
  </span>
</template>

<script>
export default {
  props: ['id_status'],
  data() {
    return {
      tipoStatus: {
        1: { title: this.$i18n.t('Aguardando Resultado'), class: 'primary', icon: 'clock' },
        2: { title: this.$i18n.t('Premiado'), class: 'success', icon: 'star' },
        3: { title: this.$i18n.t('Não Premiado'), class: 'danger', icon: 'star' },
        4: { title: this.$i18n.t('Invalidado'), class: 'dark', icon: 'ban' },
        5: { title: this.$i18n.t('Cashout'), class: 'warning', icon: 'sack-dollar' }
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
